module.exports = __webpack_public_path__ + "img/tx-_0000s_0009_10.885f8b18.png";